export const DYSCALCULIA_TASK_INSTRUCTION_VIDEOS = {
  Stroop: "DC/guide/stroop_instructions",
  DotEnumeration: "DC/guide/dot_enumeration_instructions",
  MagnitudeSymbolic: "DC/guide/sym_comp_instructions",
  MagnitudeNonSymbolic: "DC/guide/non_sym_comp_instructions",
  NumberLine: "DC/guide/numberline_instructions",
} as const;

export const READING_ASSESSMENT_COMPREHENSION_INSTRUCTION_VIDEO = "RA/comprehention_instruction_01";

export const GUIDE_VIDEO_NAMES = [
  ...Object.values(DYSCALCULIA_TASK_INSTRUCTION_VIDEOS),
  READING_ASSESSMENT_COMPREHENSION_INSTRUCTION_VIDEO,
];
